import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0C4.029 0 0 4.029 0 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zM3.495 9.517H1.226C1.215 9.345 1.2 9.174 1.2 9c0-.334.028-.661.069-.983h2.226v1.5zm1.082-4.113L3.093 3.921a7.76 7.76 0 0 1 1.083-1.038l1.461 1.461-1.06 1.06zM9 11.5A2.5 2.5 0 0 1 6.5 9c0-1.118.738-2.053 1.75-2.373V3h1.5v3.627A2.491 2.491 0 0 1 11.5 9 2.5 2.5 0 0 1 9 11.5zm3.362-7.156l1.461-1.461c.394.311.756.658 1.083 1.038l-1.484 1.483-1.06-1.06zm2.143 5.173v-1.5h2.226c.041.322.069.649.069.983 0 .174-.015.345-.026.517h-2.269z" />
    <circle cx={9} cy={9} r={1} />
  </svg>
);

export default SvgComponent;
